<script lang="ts">
    export let svg: any | null = null;
    export let src: string | null = null;
    export let color: string = "";
    export let width: string = "";
    export let keepcolors: boolean = false;
    export let size: string = "1em";
    export let mirrorx: boolean = false;
</script>

<div
    style="--color: {color}; --width: {width}; --size: {size}"
    class="icon-wrapper"
    class:color
    class:width
    class:keepcolors
    class:mirrorx
>
    {#if src}
        <img {src} alt="" />
    {/if}
    {#if svg}
        <svelte:component this={svg} />
    {/if}
</div>

<style lang="scss">
    .icon-wrapper {
        display: inline-flex;
        align-items: center;
        // margin-top: auto;
        width: auto;
        max-width: 100%;
        height: 100%;
        // padding-right: 0.5em;
        > :global(svg),
        > img {
            width: auto;
            max-width: 100%;
            height: var(--size);
            display: block;
        }
        &:not(.keepcolors) {
            :global(*) {
                color: currentColor !important;
                fill: currentColor !important;
                // stroke: currentColor !important;
            }
        }

        &.color {
            :global(*) {
                color: var(--color) !important;
                fill: var(--color) !important;
            }
        }
        &.width {
            width: var(--width) !important;
            height: 100% !important;
            > :global(svg) {
                height: auto !important;
            }
        }
        &.mirrorx {
            transform: scaleX(-1);
        }
    }
</style>
